import React, { useState } from 'react';

/**
 * Component to display a generated image with save functionality
 */
export default function GeneratedImage({ imageData, onSave }) {
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  if (!imageData?.base64) return null;

  const dataUrl = `data:image/png;base64,${imageData.base64}`;

  const handleSave = async () => {
    if (saving || saved) return;
    setSaving(true);
    try {
      // Create a download link
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `generated-${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setSaved(true);
      if (onSave) onSave(imageData);
    } catch (err) {
      console.error('Save failed:', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{
      margin: '12px 0',
      padding: '12px',
      background: '#1a1208',
      border: '1px solid #2e1e08',
      borderRadius: '12px',
    }}>
      <img
        src={dataUrl}
        alt={imageData.prompt || 'Generated image'}
        style={{
          display: 'block',
          maxWidth: '100%',
          maxHeight: '500px',
          borderRadius: '8px',
          border: '1px solid rgba(196,125,46,0.2)',
          marginBottom: '10px',
        }}
      />

      <div style={{
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
        fontSize: '12px',
        color: '#8a6a48',
      }}>
        <button
          onClick={handleSave}
          disabled={saving || saved}
          style={{
            background: saved ? '#2a4a2a' : '#c47d2e',
            color: saved ? '#90d090' : '#1a0e08',
            border: 'none',
            borderRadius: '6px',
            padding: '6px 12px',
            fontSize: '12px',
            fontWeight: 600,
            cursor: saving || saved ? 'default' : 'pointer',
            opacity: saving ? 0.6 : 1,
          }}
        >
          {saved ? '✓ Saved' : saving ? 'Saving...' : 'Save Image'}
        </button>

        {imageData.model && (
          <span style={{ color: '#6a5a38' }}>
            {imageData.model}{imageData.quality === 'hd' ? ' HD' : ''} • {imageData.size}
          </span>
        )}
      </div>

      {imageData.revisedPrompt && imageData.revisedPrompt !== imageData.prompt && (
        <div style={{
          marginTop: '8px',
          padding: '8px',
          background: '#0f0a05',
          borderRadius: '6px',
          fontSize: '11px',
          color: '#7a6a48',
          fontStyle: 'italic',
        }}>
          Revised prompt: {imageData.revisedPrompt}
        </div>
      )}
    </div>
  );
}
